import {PowderguideApiTokenStorage} from "./api/powderguide-api-token-storage";

export function addTokenToLink(link: HTMLAnchorElement, token: PowderguideApiTokenStorage) {
    const url = new URL(link.href);
    url.searchParams.set('_t', token.get());

    link.href = url.toString();
}
